import { BrowserEnvService } from '../env';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserRouting extends BaseRouting {
  static configPath = ':configId';
  static detailPath = 'detail';
  static detailDefaultPath = '';
  static galleryPath = 'gallery';
  static galleryDefaultPath = '';
  static relationPath = 'relation';
  static relationDefaultPath = '';
  static APP_ROUTE = 'browser';

  private _galleryDefault: string[] = [BrowserRouting.galleryPath];
  private _detailDefault: string[] = [BrowserRouting.detailPath];
  private _relationDefault: string[] = [BrowserRouting.relationPath];

  constructor(browserEnv: BrowserEnvService) {
    super(['/' + BrowserRouting.APP_ROUTE, BrowserRouting.configPath], browserEnv);
  }

  public galleryDefault(url: string, configId: string = this.getConfigId()): void {
    this.nav(
      this._galleryDefault,
      {
        configId
      },
      {
        queryParams: {
          url: url,
          imageId: null
        },
        queryParamsHandling: 'merge'
      }
    );
  }

  public galleryDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._galleryDefault, {
      configId
    });
  }

  public galleryDefaultAbsUrl(url: string, configId: string = this.getConfigId()): string {
    return this.absUrl(
      this._galleryDefault,
      {
        configId
      },
      {
        url: url
      }
    );
  }

  public detailDefault(url: string, imageId?: string, configId: string = this.getConfigId()): void {
    this.nav(
      this._detailDefault,
      {
        configId
      },
      {
        queryParams: {
          url: url,
          imageId: imageId
        },
        queryParamsHandling: 'merge'
      }
    );
  }

  public detailDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._detailDefault, {
      configId
    });
  }

  public detailDefaultAbsUrl(url: string, imageId?: string, configId: string = this.getConfigId()): string {
    return this.absUrl(
      this._detailDefault,
      {
        configId
      },
      {
        url: url,
        imageId: imageId
      }
    );
  }

  public relationDefaultRouteUrl(configId: string = this.getConfigId()) {
    return this.routeUrl(this._relationDefault, {
      configId
    });
  }
}
